import { render, staticRenderFns } from "./screenModel.vue?vue&type=template&id=cb566cbe&scoped=true"
import script from "./screenModel.vue?vue&type=script&lang=js"
export * from "./screenModel.vue?vue&type=script&lang=js"
import style0 from "./screenModel.vue?vue&type=style&index=0&id=cb566cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb566cbe",
  null
  
)

export default component.exports